import { createSlice } from "@reduxjs/toolkit";
import { jsConfigApi } from "apis/eduidJsConfig";
import { loginApi } from "apis/eduidLogin";
import { storeCsrfToken } from "commonConfig";
// export for use in tests
export const initialState = {
    debug: false,
    error: false,
    is_configured: false,
    preferred_captcha: "internal",
    is_app_loaded: false,
    default_country_code: "46",
};
const indexSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        appLoaded: (state) => {
            state.is_app_loaded = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(storeCsrfToken, (state, action) => {
            state.csrf_token = action.payload;
        })
            .addMatcher(jsConfigApi.endpoints.fetchJsConfig.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), action.payload.payload), { is_configured: true });
        })
            .addMatcher(loginApi.endpoints.fetchErrorInfo.matchFulfilled, (state, action) => {
            state.error_info = action.payload.payload;
        });
    },
});
export default indexSlice;
